import Hammer from 'hammerjs'
import { Navigation, TRANSITION_END, MOUSEWHEEL } from '../core'
import '../plugins/loop'

$.fn.Navigator = function(options) {
  let self = this

  if (self.data('navigator')) {
    return self.data('navigator')
  }

  self.browser = undefined
  self.lethargy = new Lethargy(7, 100, 0.05)
  self.backdrop = undefined
  self.viewport = undefined
  self.navigation = undefined
  self.hammer = undefined
  self.view_all_request = undefined
  self.current = undefined
  self.current_index = -1
  self.btn_close = undefined
  self.btn_mobile_close = undefined
  self.btn_previous = undefined
  self.btn_next = undefined
  self.is_transitioning = false
  self.is_wheeling = false
  self.buffered = false
  self.cards = {}

  self.add_card = function(card, force) {
    let card_added = false
    if (typeof force == 'undefined') {
      force = false
    }
    if (force) {
      self.cards['card_' + card.attr('data-index')] = card
      self.current.parent().append(card)
      card_added = true
    } else {
      if (self.current.viewer_index == -1 && self.current.attr('data-id') == card.attr('data-id')) {
        self.current.attr('data-index', card.attr('data-index'))
        self.current_index = parseInt(self.current.attr('data-index'), 10)
      } else if (self.current != undefined && card.viewer_index != self.current.viewer_index) {
        self.cards['card_' + card.attr('data-index')] = card
        if (card.viewer_index != self.current.viewer_index) {
          self.current.before(card)
          card_added = true
        }
      }
    }
    if (card_added) {
      self.browser.find('.navigator-item').sort(function(a, b) {
        return $(a).attr('data-index') - $(b).attr('data-index')
      }).appendTo(self.viewport)
    }
    return card_added
  }

  self.initialize_cards = function(action) {
    if (self.is_transitioning) {
      return false
    }
    self.is_transitioning = true
    self.browser.find('.navigator-item').removeClass('navigator-item--current navigator-item--previous navigator-item--previous-2 navigator-item--previous-3 navigator-item--previous-4 navigator-item--next navigator-item--next-2 navigator-item--next-3 navigator-item--next-4')
    let numberOfCards = self.browser.find('.navigator-item').length
    // self.browser.find('.navigator-item').sort(function(a, b) {
    //   return $(a).attr('data-index') - $(b).attr('data-index')
    // }).appendTo(self.viewport)
    self.current.addClass('navigator-item--current')
    requestAnimationFrame(function() {
      if (numberOfCards >= 5) {
        self.current.loop_prev(2).addClass('navigator-item--previous-2')
      }
      self.current.loop_prev().addClass('navigator-item--previous').MobileCard().close_content()
      self.current.loop_next().addClass('navigator-item--next').MobileCard().close_content()
      if (numberOfCards >= 5) {
        self.current.loop_next(2).addClass('navigator-item--next-2')
      }
      if (action == undefined) {
        self.is_transitioning = false
        self.is_wheeling = false
      } else {
        setTimeout(function() {
          self.is_transitioning = false
          requestAnimationFrame(function() {
            self.is_wheeling = false
            if (self.buffered == 'previous') {
              self.go_to('previous')
            } else if (self.buffered == 'next') {
              self.go_to('next')
            }
            self.buffered = false
          })
        }, 500)
      }
    })
  }

  self.go_to = function(direction) {
    if (Object.keys(self.cards).length < 2) {
      return false
    }
    if (self.is_transitioning) {
      if (!self.is_wheeling) {
        self.buffered = direction
      }
      return false
    }
    self.current_index += (direction == 'next') ? 1 : -1
    if (direction == 'previous' && self.current_index < 0) {
      self.current_index = self.browser.find('.navigator-item').length - 1
    } else if (direction == 'next' && self.current_index > $('.navigator-item').length - 1) {
      self.current_index = 0
    }
    self.current = $('.navigator-item[data-index="' + self.current_index + '"]')
    self.navigation.replaceMeta(JSON.parse(self.current.find('.schema-graph').html()), JSON.parse(self.current.find('.schema-data').html()))
    self.initialize_cards(direction)
    if (!self.navigation.isPopping) {
      document.title = self.current.data('title')
      let pushState = self.navigation.getStateObject({
        namespace: self.options.singleClass,
        card_index: self.current.attr('data-index'),
      }, true)
      self.navigation.pushState(pushState, self.current.data('title'), self.current.data('url'))
    }
    self.navigation.isPopping = false
  }

  self.mobile_close = function(e) {
    if ($.mlmi.mobile.isMobile && self.current != undefined && self.current.MobileCard().expanded) {
      self.current.MobileCard().close_content()
      return false
    }
  }

  self.close = function(e) {
    if ($('body').hasClass(self.options.singleClass) && Object.keys(self.cards).length < 2) {
      return false
    }
    if (self.navigation != undefined) {
      self.navigation.abortRequest()
    }
    if (self.view_all_request != undefined) {
      self.view_all_request.abort()
      self.view_all_request = undefined
    }
    if (e == undefined && $('body').hasClass(self.options.singleClass)) {
      location.href = self.options.closeButtonURL
      return
    }
    $('.app').css('top', '')
    $('html, body').removeClass('--no-scroll')
    requestAnimationFrame(function() {
      $(window).scrollTop($(window).data('scrollTop'))
    })
    if (self.browser != undefined) {
      self.browser.on(TRANSITION_END, function(e) {
        if (self.browser != undefined && e.target == self.browser.get(0)) {
          self.browser.off(TRANSITION_END)
          self.reset()
          self.navigation.replaceMeta(JSON.parse($('main').find('.schema-graph').html()), JSON.parse($('main').find('.schema-data').html()))
          if (!self.navigation.isPopping) {
            let pushState = self.navigation.getStateObject({
              namespace: self.options.singleClass,
            })
            self.navigation.pushState(pushState, $('.app').data('title'), $('.app').data('url'))
            document.title = $('.app').data('title')
          }
          self.navigation.isPopping = false
        }
      }).addModifier('closing')
      $(document).off('click', '.navigator__btn-close', self.close)
      $(document).off('keydown', self.keypressed)

    }
    return false
  }

  self.state_popped = function(href, popState) {
    if (popState.namespace == self.options.singleClass) {
      if (popState.card_index == undefined) {
        self.navigation.isPopping = true
        $.mlmi.navigators.current.close()
      } else if (self.current_index === -1) {
        self.navigation.isPopping = true
        $(self.navigation.options.selectors.links + '[data-index="' + popState.card_index + '"]').click()
      } else {
        if (popState.card_index == self.current_index + 1) {
          self.navigation.isPopping = true
          self.go_to('next')
        } else if (popState.card_index == self.current_index - 1) {
          self.navigation.isPopping = true
          self.go_to('previous')
        } else if (popState.card_index < self.current_index) {
          self.navigation.isPopping = true
          self.go_to('next')
        } else {
          self.navigation.isPopping = true
          self.go_to('previous')
        }
      }
    }
  }

  self.pop_state_filter = function(stateObject, action) {
    /* Push state */
    if (action == 'pushState') {
      if (stateObject.namespace == undefined) {
        let navigatorItem = self.navigation.currentContent.find('.navigator-item')
        if (navigatorItem.length == 1) {
          stateObject.namespace = self.options.singleClass
          stateObject.card_index = navigatorItem.first().attr('data-index')
        }
      }
    }

    return stateObject
  }

  self.create_browser = function() {
    self.browser = $('<div>').addClass('navigator').BlockElement()
    self.backdrop = $('<div>').addClass('navigator__backdrop').BlockElement()
    self.viewport = $('<div>').addClass('navigator__viewport').BlockElement()
    self.btn_close = $('<a>').addClass('navigator__btn-close').text(regionportneuf_l10n.BACK).attr('href', self.options.closeButtonURL).BlockElement()
    self.btn_mobile_close = $('<a>').addClass('navigator__btn-mobile-close').BlockElement()
    self.btn_previous = $('<button>').addClass('navigator__btn-previous').BlockElement()
    self.btn_next = $('<button>').addClass('navigator__btn-next').BlockElement()
    self.browser.append(self.backdrop).append(self.viewport).append(self.btn_close).append(self.btn_mobile_close).append(self.btn_previous).append(self.btn_next)
    $('body').append(self.browser)
    self.btn_close.off('click').on('click', self.close)
    self.btn_mobile_close.off('click').on('click', self.mobile_close)
    self.btn_previous.off('click').on('click', function() {
      self.go_to('previous')
    })
    self.btn_next.off('click').on('click', function() {
      self.go_to('next')
    })
    $('.app').css('top', '-' + $(window).scrollTop() + 'px')
    $(window).data('scrollTop', $(window).scrollTop())
    $('html, body').addClass('--no-scroll')
    self.init_scrolling()
    requestAnimationFrame(function() {
      self.browser.addModifier('visible')
    })
  }

  self.link_clicked = function(link) {
    if (self.browser == undefined) {
      if (!self.navigation.isPopping) {
        let currentState = window.history.state
        if (currentState == null) {
          currentState = self.navigation.getStateObject(undefined, false)
        }
        currentState.namespace = self.options.singleClass
        self.navigation.replaceState(currentState)
      }
      self.navigation.isPopping = false
      self.create_browser()
    }
    self.browser.addModifier('loading')
  }

  self.page_loaded = function(event, loaded_content) {
    if (loaded_content == undefined) {
      return false // ignore
    }
    let response = $('<html>').html(loaded_content),
    type = response.find('.navigator-item').data('type'),
    category = response.find('.navigator-item').data('category')
    if (!category) {
      category = ''
    }
    if (self.current != undefined) {
      let former = self.current
      requestAnimationFrame(function() {
        former.on(TRANSITION_END, function(e) {
          if (e.target == former.get(0)) {
            former.off(TRANSITION_END)
            former.remove()
          }
        }).addModifier('leaving')
      })
    }
    if (self.browser == undefined) {
      self.create_browser()
    }
    let previousIndex = self.current_index
    self.browser.removeModifier('loading')
    self.current = response.find('.navigator-item').BlockElement()
    self.navigation.replaceMeta(JSON.parse(self.current.find('.schema-graph').html()), JSON.parse(self.current.find('.schema-data').html()))
    self.current_index = parseInt(self.current.attr('data-index'), 10)
    if (previousIndex == -1) {
      // no direction
    } else if (previousIndex > 2 && self.current_index == 1) {
      self.browser.removeModifier('previous').addModifier('next')
    } else if (previousIndex == 1 && self.current_index > 2) {
      self.browser.removeModifier('next').addModifier('previous')
    } else if (self.current_index > previousIndex) {
      self.browser.removeModifier('previous').addModifier('next')
    } else if (self.current_index < previousIndex) {
      self.browser.removeModifier('next').addModifier('previous')
    }
    self.viewport.append(self.current)
    if (self.options.navigatorPageLoad != undefined) {
      self.options.navigatorPageLoad(self.current, self)
    }
    requestAnimationFrame(function() {
      self.current.addModifier('current')
    })
  }

  self.reset = function() {
    self.browser.remove()
    self.browser = undefined
    self.viewport = undefined
    self.current = undefined
    self.current_index = -1
    self.btn_close = undefined
    for (let card_key in self.cards) {
      self.cards[card_key].remove()
    }
    self.cards = {}
  }

  self.keypressed = function(e) {
    const key = e.keyCode || e.which
    if ([32, 40].indexOf(key) !== -1) {
      self.go_to('next')
    } else if ([38].indexOf(key) !== -1) {
      self.go_to('previous')
    }
  }

  self.end_wheeled = function() {
    self.wheel_delta = 0
  }

  self.wheeled = function(e) {
    let action = self.lethargy.check(e)
    if (self.is_wheeling) {
      return false
    }
    if (self.is_transitioning) {
      return false
    }
    if (action === 1) {
      self.is_wheeling = true
      self.go_to('previous')
    } else if (action === -1) {
      self.is_wheeling = true
      self.go_to('next')
    }
  }

  self.swiped = function(e) {
    if (self.is_transitioning) {
      return false
    }
    if (e.type == 'swipeup') {
      self.go_to('next')
    } else if (e.type == 'swipedown') {
      self.go_to('previous')
    }
  }

  self.init_scrolling = function() {
    self.hammer = new Hammer(self.browser.get(0))
    self.hammer.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL })
    self.hammer.on('swipeup swipedown', self.swiped)
    self.browser.on(MOUSEWHEEL, self.wheeled)
    $(document).on('keydown', self.keypressed)
  }

  self.init_navigation = function() {
    self.navigation = new Navigation(self.options.navigationOptions)
  }

  self.init_standalone = function() {
    self.create_browser()
    self.browser.removeModifier('loading')
    self.current = $('.navigator-item').BlockElement()
    self.current_index = parseInt(self.current.attr('data-index'), 10)
    self.viewport.append(self.current)
    if (self.options.navigatorPageLoad != undefined) {
      self.options.navigatorPageLoad(self.current, self)
    }
    requestAnimationFrame(function() {
      self.current.addModifier('current')
    })
  }

  self.options = $.extend(true, {
    singleClass: 'single',
    closeButtonURL: '/',
    navigatorPageLoad: undefined,
    navigationOptions: {
      useTransition: false,
      useHistory: true,
      autoReplaceState: false,
      selectors: {
        pageTarget: false,
      },
      on: {
        linkClicked: self.link_clicked,
        popState: self.state_popped,
      },
      filter: {
        popState: self.pop_state_filter,
      },
    },
  }, options)

  return function() {
    self.init_navigation()
    $(window).on('page_load', self.page_loaded)
    if ($('body').hasClass(self.options.singleClass)) {
      self.init_standalone()
    }
    self.data('navigator', self)
    return self
  }()
}

export default {
  init(options) {
    return $('<div></div>').Navigator(options)
  },
}
